module.exports = __webpack_public_path__ + "static/fonts/dmsansregular-zvwm3.8c79e876.ttf";